import { Plural, Trans, useLingui } from '@lingui/react/macro';

import ContactDetails from '@/components/ContactDetails';
import AlertBar from '@/design_system/AlertBar';
import Box from '@/design_system/Box';
import Stack from '@/design_system/Stack';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { ArticleWithRelations, RequestWithRelations } from '@/models/request';

import { ArticleCard } from '../../shared/ClientArticlesList/components/ArticleCard';
import { StepMessage } from '../../shared/StepMessage';

const Refused = ({
  request,
  articles,
}: {
  request: RequestWithRelations;
  articles: ArticleWithRelations[];
}) => {
  const { t } = useLingui();

  const isViaStore = !!request.storeId;
  const storeName = request.store?.name;

  return (
    <BrandRequestMainContent>
      <Stack gap="1rem">
        <StepMessage
          message={
            <span>
              <Trans id="client.request.refusal.refused.title">
                Your after-sales service request has been cancelled.
              </Trans>{' '}
              {isViaStore && (
                <Trans id="client.request.refusal.refused.store-pickup">
                  You can now pick up your{' '}
                  <Plural value={request.articles.length} one="item" other="items" /> at the{' '}
                  <b>{storeName}</b> store.
                </Trans>
              )}
            </span>
          }
        />

        {isViaStore && (
          <AlertBar type="info" hideIcon size="large">
            <ContactDetails
              type="store"
              name={request.store?.name}
              email={request.store?.address?.contactEmail}
              address={request.store?.address}
              phone={request.store?.contactInfo?.phone}
              openingHours={request.store?.storeConfig?.openingHours}
            />
          </AlertBar>
        )}

        <Box padding="0" ariaLabel={t({ id: 'client.articles.table.label', message: 'Items' })}>
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </Box>
      </Stack>
    </BrandRequestMainContent>
  );
};

export default Refused;
